import {createStyles} from '@material-ui/core';

const style = createStyles({
  container: {
    display: 'flex',
    gap: '16px',
    alignItems: 'center',
  },
  container__buttons: {
    display: 'flex',
    gap: '10px',
  },
  input: {
    paddingTop: '12px',
    width: '250px',
  },
});

export default style;
